import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpinnerContainer, SpinnerDescription, SpinnerLayout, SpinnerTitle } from './LoadingSpinner.styles';
import { SpinnerIcon } from '../Icon';
import { useTranslation } from '@ciam/i18n';
import { useLoadingSpinnerStore } from './store';
export const LoadingSpinner = () => {
    const { t } = useTranslation('ui');
    const { isLoading, message } = useLoadingSpinnerStore();
    if (!isLoading)
        return null;
    const defaultTitle = t('loading-spinner.initial-message.title');
    const defaultDescription = t('loading-spinner.initial-message.description');
    const title = message?.title || defaultTitle;
    const description = message?.description || defaultDescription;
    return (_jsx(SpinnerLayout, { children: _jsxs(SpinnerContainer, { children: [_jsx(SpinnerIcon, {}), title && _jsx(SpinnerTitle, { children: title }), description && _jsx(SpinnerDescription, { children: description })] }) }));
};
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map